module.exports = __webpack_public_path__ + "img/header-engagementRingsTensionRing.1b7c820.webp";